import { render, staticRenderFns } from "./CoreBanner.vue?vue&type=template&id=7b597b60&scoped=true&"
import script from "./CoreBanner.vue?vue&type=script&lang=js&"
export * from "./CoreBanner.vue?vue&type=script&lang=js&"
import style0 from "./CoreBanner.vue?vue&type=style&index=0&id=7b597b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b597b60",
  null
  
)

export default component.exports